/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Create_MineInputs */

const en_create_mine = /** @type {(inputs: Create_MineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create Mine`)
};

/** @type {(inputs: Create_MineInputs) => LocalizedString} */
const es_create_mine = en_create_mine;

/** @type {(inputs: Create_MineInputs) => LocalizedString} */
const fr_create_mine = en_create_mine;

/** @type {(inputs: Create_MineInputs) => LocalizedString} */
const de_create_mine = en_create_mine;

/** @type {(inputs: Create_MineInputs) => LocalizedString} */
const ja_create_mine = en_create_mine;

/** @type {(inputs: Create_MineInputs) => LocalizedString} */
const zh_create_mine = en_create_mine;

/** @type {(inputs: Create_MineInputs) => LocalizedString} */
const ar_create_mine = en_create_mine;

/** @type {(inputs: Create_MineInputs) => LocalizedString} */
const id_create_mine = en_create_mine;

/** @type {(inputs: Create_MineInputs) => LocalizedString} */
const it_create_mine = en_create_mine;

/** @type {(inputs: Create_MineInputs) => LocalizedString} */
const ru_create_mine = en_create_mine;

/** @type {(inputs: Create_MineInputs) => LocalizedString} */
const pt_create_mine = en_create_mine;

/** @type {(inputs: Create_MineInputs) => LocalizedString} */
const ko_create_mine = en_create_mine;

/**
* | output |
* | --- |
* | "Create Mine" |
*
* @param {Create_MineInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const create_mine = /** @type {((inputs?: Create_MineInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Create_MineInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_create_mine(inputs)
	if (locale === "es") return es_create_mine(inputs)
	if (locale === "fr") return fr_create_mine(inputs)
	if (locale === "de") return de_create_mine(inputs)
	if (locale === "ja") return ja_create_mine(inputs)
	if (locale === "zh") return zh_create_mine(inputs)
	if (locale === "ar") return ar_create_mine(inputs)
	if (locale === "id") return id_create_mine(inputs)
	if (locale === "it") return it_create_mine(inputs)
	if (locale === "ru") return ru_create_mine(inputs)
	if (locale === "pt") return pt_create_mine(inputs)
	return ko_create_mine(inputs)
});